<template>
    <div class="row m-order" v-if="profile">
        <template v-if="profile.verification.value !== '2'">
            <span class="icon-text times" v-if="profile.verification.value == '4'">{{ profile.verification.name }}</span>
            <div class="iframe-verification" :class="isActive && 'active'">
                <iframe :src="'https://api.xbt.kg/ru/sumsub/widget?token=' + token" allow="camera; microphone; geolocation"></iframe>
                <div class="p-2">
                    <span class="button button-default block lg" role="button" v-on:click="isActive = !isActive">Закрыть</span>
                </div>
            </div>
            <div v-if="!isActive">
                <span class="button button-default block lg" role="button" v-on:click="isActive = !isActive">Начать верификацию</span>
            </div>
        </template>
    </div>
    <template v-if="profile && profile.verification.value == '2'">
        <div class="dashboard-personal-wrap">
            <span class="icon-text v2 my-4 check">{{ profile.verification.name }}</span>
        </div>
    </template>
</template>

<script>
import VerificationIcon from '../../assets/img/banner.svg'

export default {
    data() {
        return {
            token: '',
            isActive: true,
            VerificationIcon: VerificationIcon
        }
    },
    created() {
        this.token = localStorage.getItem('token')
    },
    computed: {
        profile() {
            return this.$store.getters.getProfile
        }
    }
}
</script>